<span class="w-full not-found-container flex flex-col gap-4 items-center justify-center mt-10">
    <span class="text-2xl font-medium">Accès interdit</span>
    <p>Il semblerait que vous n'ayez pas accès à cet outil. Veuillez contacter votre responsable pour effectuer une demande d'ouverture de droits via TAGADA.</p>
</span>